import { createSlice } from "@reduxjs/toolkit";
import { act } from "react";
let cache = [];
const initialState = {
  presets:{},
  values: {},
  id: -1,
  key: "",
  error: {
    timeStamp : "",
    message : ""
  }
};

export const formSlice = createSlice({
  name: "form",
  initialState: initialState,
  reducers: {
    
    setFormError:(state , action)=>{
      state.error = {timeStamp : Date.now() , message: action.payload }
    },
    resetForm:(state , action ) =>{
      if(action.payload && action.payload.cache){
        cache.push(JSON.parse(JSON.stringify(state)))
        state.key=""
        state.id=-1
        state.values={}
        state.presets={}
        state.error={
          timeStamp : "",
          message : ""
        }
      } else{
      if(cache.length){
         const prev = cache.pop();
        // Restore previous state fields
        state.values = prev.values;
        state.id = prev.id;
        state.key = prev.key;
        state.error = prev.error
        state.presets=prev.presets
      } else {
        state.key=""
        state.id=-1
        state.values={}
        state.presets={}
        state.error = {
          timeStamp : "",
          message : ""
        }
      }}
    },
    setFormValues:(state, action) => {
      const { id, ...rest } = action.payload;
      if (id !== undefined) {
        state.id = id;
      }
      for (var key of Object.keys(rest)){
        if (rest[key] == null){
          delete rest[key]
        }
      }
      state.values = { ...rest };

    },
    setPresets:(state,action)=>{
      state.presets = action.payload
    },
    setFormValue: (state, action) => {
      // Example: { key: "fieldName", value: "fieldValue" }
      if (action.payload.key == "id"){
        state.id = action.payload.value
        return
      }
      if (action.payload.value === null) { delete state.values[action.payload.key]}
      state.values[action.payload.key] = action.payload.value;
    },
    setFormData: (state, action) => {
      state.values = action.payload.value;
      if (action.payload.id) {
        state.id = action.payload.id;
      }
    },
    setFormAlert: (state, action) => {
      state.alert = action.payload;
    },
  },
});

export const {setPresets, resetForm , setFormError , setFormAlert, setFormData, setFormValue, closeForm , setFormValues} = formSlice.actions;
export default formSlice.reducer;